import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created date',
    dataIndex: 'addedAt',
    key: 'addedAt',
    customRender: ({ text }) => dateFormat(text, 'DD/MM/YYYY HH:MM'),
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    customRender: ({ record }) => (
      record.valueType === 'fixed'
        ? `$${record.value}`
        : `${record.value}%`
    ),
  },
  {
    title: 'Users limit',
    dataIndex: 'limitPerUserType',
    key: 'limitPerUserType',
  },
  {
    title: 'Users',
    dataIndex: 'userLimitType',
    key: 'userLimitType',
    customRender: ({ record }) => (
      record.userLimitType === 'any'
        ? 'All users'
        : 'Specific users'
    ),
  },
  {
    title: 'Dates',
    dataIndex: 'activeIntervals',
    key: 'activeIntervals',
    customRender: ({ record }) => {
      const intervals = record.activeIntervals;
      let result;
      if (intervals && intervals.length) {
        result = intervals.reduce((acc, interval) => (
          `${acc}${dateFormat(interval.startDate, 'DD/MM/YYYY')} - ${dateFormat(interval.endDate, 'DD/MM/YYYY')}\n`
        ), '');
      } else {
        result = 'Not data';
      }
      return result;
    },
  },
  {
    title: 'Code limit',
    dataIndex: 'codeLimitType',
    key: 'codeLimitType',
  },
  {
    title: 'Active',
    dataIndex: 'isActive',
    key: 'isActive',
    customRender: ({ record }) => (record.isActive === true
      ? <span style={'color: green'}>Active</span>
      : <span style={'color: red'}>Not Active</span>
    ),
  },
  {
    title: 'Is Deleted',
    dataIndex: 'isDeleted',
    key: 'isDeleted',
    customRender: ({ text }) => (text ? <span style={'color: red'}>Yes</span> : 'No'),
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
